import FormModal from '@ovComponents/3-pattern/legacyFormModal/formModal';
import { Button, IconButton } from 'hephaestus/web';
import { AddRounded as AddIcon } from 'hephaestus/webIcons';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type CreateNewModalProp = {
  onSubmit?: (event: any) => void;
  loading?: boolean;
  children?: any[] | any;
  title?: string;
  fullWidth?: boolean;
  sx?: any;
  buttonType?: 'BUTTON' | 'ICON' | 'NONE';
  maxWidth?: string;
  disabled?: boolean;
  modalOpenDisabled?: boolean;
  iconType?: 'ADD' | 'EDIT' | 'DOT';
  buttonText?: string;
  hideSubmit?: boolean;
  modalButton?: string;
  icon?: any;
  buttonVariant?: 'outlined' | 'text' | 'contained' | undefined;
  forceOpen?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
};

const CreateNewModal = ({
  onSubmit,
  loading,
  children,
  title,
  fullWidth = false,
  sx,
  buttonType = 'BUTTON',
  maxWidth = 'sm',
  buttonText,
  disabled = false,
  disableButton = false,
  icon = <AddIcon data-testid='add-icon' />,
  hideSubmit = false,
  modalButton,
  buttonVariant = 'contained',
  forceOpen = false,
  onClose,
  onOpen,
  state,
  initialState,
}: {
  onSubmit: (event: any) => void;
  loading: boolean;
  children: any[] | any;
  title: string;
  fullWidth?: boolean;
  sx?: any;
  buttonType?: 'BUTTON' | 'ICON' | 'NONE';
  maxWidth?: string;
  disabled?: boolean;
  disableButton?: boolean;
  iconType?: 'ADD' | 'EDIT' | 'DOT';
  buttonText?: string;
  hideSubmit?: boolean;
  modalButton?: string;
  icon?: any;
  buttonVariant?: 'outlined' | 'text' | 'contained' | undefined;
  forceOpen?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
  state?: any;
  initialState?: any;
}) => {
  const { t } = useTranslation(['shared']);
  const [open, setOpen] = useState(forceOpen);

  const handleClickOpen = () => {
    if (onOpen) onOpen();
    setOpen(true);
  };

  const handleClose = () => {
    if (onClose) onClose();
    setOpen(false);
  };

  const submit = (event: any) => {
    try {
      event.preventDefault();
      event.stopPropagation();
      onSubmit(event);
      setOpen(false);
    } catch (error) {
      console.error('validation errors', error);
    }
  };

  return (
    <>
      {buttonType === 'NONE' ? (
        <Button
          variant='text'
          disabled={disableButton}
          onClick={handleClickOpen}
          sx={sx}
          fullWidth={fullWidth}
          data-testid='add-button'
        >
          {modalButton || t('shared:add')}
        </Button>
      ) : buttonType === 'ICON' ? (
        <IconButton
          aria-label='add'
          disabled={disableButton}
          data-testid='add-button'
          onClick={handleClickOpen}
        >
          {icon}
        </IconButton>
      ) : (
        <Button
          variant={buttonVariant}
          disabled={disableButton}
          onClick={handleClickOpen}
          sx={sx}
          fullWidth={fullWidth}
          startIcon={icon}
          data-testid='add-button'
        >
          {modalButton || t('shared:add')}
        </Button>
      )}
      <FormModal
        hideSubmitButton={hideSubmit}
        onSubmit={submit}
        loading={loading}
        disabled={disabled}
        children={children}
        title={title}
        open={open}
        handleClose={handleClose}
        formButton={buttonText || t('shared:create')}
        maxWidth={maxWidth}
        state={state}
        initialState={initialState}
      />
    </>
  );
};

export default CreateNewModal;
